const MetricsPage = () => {
  return (
    <div>MetricsPage</div>
  );
};

export default MetricsPage;
